export function capitalize(text) {
    return text.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}

export function downloadFile(uri, data, filename){
    const output = `${uri},${data}`;
    const link = document.createElement('a');
    link.setAttribute('href', output);
    link.setAttribute('download', filename);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function translateSiteName(data) {
   
   return data.clientPropertyRef != null && data.clientPropertyRef.length > 8 ? data.clientPropertyRef : (
                
        (data.address_1 != null ? data.address_1 + " " : "") +
        (data.address_2 != null ? data.address_2 + " " : "") +
        (data.address_3 != null ? data.address_3 + " " : "") +
        (data.address_4 != null ? data.address_4 + " " : "") +
        (data.county != null ? data.county + "" : "") ) !== "" ? 
        
        (data.address_1 != null ? data.address_1 + " " : "") +
        (data.address_2 != null ? data.address_2 + " " : "") +
        (data.address_3 != null ? data.address_3 + " " : "") +
        (data.address_4 != null ? data.address_4 + " " : "") +
        (data.county != null ? data.county + "" : "") : data.companySiteName


}

export function translateSupplyAddress(data) {
   
    return data.supplyAddress != null ? data.supplyAddress : (
                 
         (data.propertyName != null ? data.propertyName + " " : "") +
         (data.siteAddress != null ? data.siteAddress + " " : "") +
         (data.town != null ? data.town + " " : "") +
         (data.postCode != null ? data.postCode + " " : "") +
         (data.county != null ? data.county + "" : "") )
         
 
 
 }